import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import MailIcon from '@mui/icons-material/Mail';
import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg';
import { Badge, Stack, Tooltip, Typography } from '@mui/material';
import { useMemo, useState } from 'react';
import { Contact } from '../../../sic-lib/types/Contact';
import DialogRevokeConsent from './DialogRevokeConsent';

interface Props {
    contact: Contact;
}

export function ConsentInfo({ contact }: Props) {
    const [revokeDialogOpen, setRevokeDialogOpen] = useState(false);

    const consentStatus = useMemo(() => {
        if (contact.consent?.expressConsent) {
            return 'Express Consent';
        } else if (contact.consent?.impliedConsent) {
            const expiresStr = contact.consent?.impliedConsentExpiry
                ? `expires on ${new Date(
                      contact.consent?.impliedConsentExpiry,
                  ).toLocaleDateString()}`
                : '';

            return `Implied ${expiresStr}`;
        } else if (contact.consent?.impliedConsentExpiry) {
            return `Expired on ${new Date(
                contact.consent?.impliedConsentExpiry,
            ).toLocaleDateString()}`;
        } else {
            return 'Not Obtained';
        }
    }, [contact.consent]);

    const handleShowDialog = () => {
        setRevokeDialogOpen(true);
    };

    return (
        <Stack spacing={1}>
            <Typography variant="subtitle2" textAlign="center" mb={1}>
                Consent Status
            </Typography>
            <Stack
                direction="row"
                spacing={2}
                justifyContent="center"
                onClick={handleShowDialog}
                style={{ cursor: 'pointer' }}
            >
                <Tooltip title="Email Consent">
                    <Badge
                        badgeContent={
                            contact.consent?.emailConsent ? (
                                <CheckIcon fontSize="small" />
                            ) : (
                                <CloseIcon fontSize="small" />
                            )
                        }
                        color={contact.consent?.emailConsent ? 'success' : 'error'}
                        sx={{
                            '.MuiBadge-badge': {
                                padding: 0,
                                fontSize: '1.5rem',
                            },
                        }}
                    >
                        <MailIcon color="action" fontSize="large" />
                    </Badge>
                </Tooltip>
                <Tooltip title="Telephony Consent">
                    <Badge
                        badgeContent={
                            contact.consent?.smsConsent ? (
                                <CheckIcon fontSize="small" />
                            ) : (
                                <CloseIcon fontSize="small" />
                            )
                        }
                        color={contact.consent?.smsConsent ? 'success' : 'error'}
                        sx={{
                            '.MuiBadge-badge': {
                                padding: 0,
                            },
                        }}
                    >
                        <PermPhoneMsgIcon color="action" fontSize="large" />
                    </Badge>
                </Tooltip>
            </Stack>
            <Stack>
                <Typography variant="body2" textAlign="center">
                    {consentStatus}
                </Typography>
            </Stack>
            <DialogRevokeConsent
                contact={contact}
                isOpen={revokeDialogOpen}
                setShowDialog={setRevokeDialogOpen}
            />
        </Stack>
    );
}
